import React from 'react';
import { IVisitorDetailsStepProps } from './types';
import { Formik } from 'formik';
import VisitorDetailsForm from './VisitorDetailsForm';
import useStepper from '../../../stepper/useStepper';
import schema from './schema';

const getInitialTouched = (values: {
  [key: string]: any;
}): { [key: string]: any } => {
  const touched: { [key: string]: any } = {};

  Object.keys(values).forEach((key) => {
    if (values[key]) {
      touched[key] = true;
    }
  });

  return touched;
};

const VisitorDetailsStep: React.FC<IVisitorDetailsStepProps> = ({
  initialValues,
  visitorTypeId,
  onVisitorTypeChange,
  onSubmit,
}) => {
  const { hasNext, showNext, onFinish } = useStepper();

  return (
    <Formik
      initialValues={initialValues}
      initialTouched={getInitialTouched(initialValues)}
      validationSchema={schema}
      onSubmit={(values) => {
        onSubmit(values);

        hasNext ? showNext() : onFinish();
      }}
    >
      <VisitorDetailsForm
        visitorTypeId={visitorTypeId}
        onVisitorTypeChange={onVisitorTypeChange}
      />
    </Formik>
  );
};

export default VisitorDetailsStep;
